import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { useNotificationContext } from '../../context/NotificationContext';
import { getNotificationOriginName } from '../../utils';

const NotificationFeed = () => {
    const history = useHistory();
    const { notifications, unreadCount, markAsRead, markAllAsRead, clearNotifications } = useNotificationContext();
    const recentNotifications = notifications.slice(0, 8);

    const openNotification = (notification) => {
        markAsRead(notification.id);
        if (notification.link) {
            history.push(notification.link);
        }
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Recent Notifications</h4>
                    <div className="d-flex align-items-center gap-2">
                        {unreadCount > 0 && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={markAllAsRead}
                            >
                                Mark all read
                            </button>
                        )}
                        {notifications.length > 0 && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={clearNotifications}
                            >
                                Clear all
                            </button>
                        )}
                    </div>
                </div>

                {recentNotifications.length === 0 ? (
                    <p className="text-muted mb-0">No notifications yet.</p>
                ) : (
                    <div className="list-group">
                        {recentNotifications.map((notification) => {
                            const originName = getNotificationOriginName(notification);
                            return (
                            <button
                                key={notification.id}
                                type="button"
                                className={`list-group-item list-group-item-action text-start ${notification.read ? '' : 'list-group-item-light'}`}
                                onClick={() => openNotification(notification)}
                            >
                                <div className="d-flex justify-content-between">
                                    <strong>{notification.title}</strong>
                                    <small className="text-muted">{moment(notification.createdAt).fromNow()}</small>
                                </div>
                                {originName && (
                                    <div className="small mt-1 text-primary">
                                        From: {originName}
                                    </div>
                                )}
                                <div className="text-muted small mt-1">{notification.message}</div>
                            </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationFeed;
